export const PAYMENT_CARD_BINDING_AMOUNT = 1;
